import React, { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';

const CoordinationChantiers = () => {
  const { t } = useTranslation();
  const sectionRef = useRef(null);

  const renderIcon = (iconType) => {
    const iconProps = { width: "35", height: "35", fill: "#4CAF50" };
    
    switch(iconType) {
      case 'meeting':
        return (
          <svg {...iconProps} viewBox="0 0 24 24">
            <path d="M16,4C18.2,4 20,5.8 20,8C20,10.2 18.2,12 16,12C13.8,12 12,10.2 12,8C12,5.8 13.8,4 16,4M16,14C18.7,14 24,15.3 24,18V20H8V18C8,15.3 13.3,14 16,14M8,12C10.2,12 12,10.2 12,8C12,5.8 10.2,4 8,4C5.8,4 4,5.8 4,8C4,10.2 5.8,12 8,12M8,14C5.3,14 0,15.3 0,18V20H8V18C8,16.2 8.7,15.2 10.4,14.6C9.7,14.2 8.9,14 8,14Z"/>
          </svg>
        );
      case 'documents':
        return (
          <svg {...iconProps} viewBox="0 0 24 24">
            <path d="M16,0H8A2,2 0 0,0 6,2V18A2,2 0 0,0 8,20H20A2,2 0 0,0 22,18V6L16,0M20,18H8V2H15V7H20V18Z"/>
          </svg>
        );
      case 'planning':
        return (
          <svg {...iconProps} viewBox="0 0 24 24">
            <path d="M9,10H7V12H9V10M13,10H11V12H13V10M17,10H15V12H17V10M19,3H18V1H16V3H8V1H6V3H5C3.89,3 3,3.9 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5A2,2 0 0,0 19,3M19,19H5V8H19V19M9,14H7V16H9V14M13,14H11V16H13V14M17,14H15V16H17V14Z"/>
          </svg>
        );
      case 'tools':
        return (
          <svg {...iconProps} viewBox="0 0 24 24">
            <path d="M13.78,15.3L19.78,21.3L21.89,19.14L15.89,13.14L13.78,15.3M17.5,10.1C17.11,10.1 16.69,10.05 16.36,9.91L4.97,21.25L2.86,19.14L10.27,11.74C8.5,8.91 9.91,4.54 13.5,4.54C14.4,4.54 15.37,4.69 16.5,4.91L12.34,9.05L14.36,11.09L18.55,6.9C18.74,7.95 18.89,8.93 18.89,9.82C18.89,12.08 18.39,12.78 17.5,10.1M2.86,4.91L6.05,1.65L4.91,2.79L13.25,11.13L12.84,11.54C12.84,11.54 12.84,11.54 12.84,11.54L2.86,4.91Z"/>
          </svg>
        );
      default:
        return null;
    }
  };

  useEffect(() => {
    if (window.IntersectionObserver) {
      const observer = new IntersectionObserver(([entry]) => {
        if (entry.isIntersecting) {
          sectionRef.current.classList.add('visible');
          observer.disconnect();
        }
      }, { threshold: 0.2 });
      
      if (sectionRef.current) {
        observer.observe(sectionRef.current);
      }
      
      return () => observer.disconnect();
    }
  }, []);

  const missions = [
    {
      title: t('coordination.mission1.title'),
      description: t('coordination.mission1.description'),
      icon: "meeting",
      color: "#4CAF50"
    },
    {
      title: t('coordination.mission2.title'),
      description: t('coordination.mission2.description'),
      icon: "documents",
      color: "#4CAF50"
    },
    {
      title: t('coordination.mission3.title'),
      description: t('coordination.mission3.description'),
      icon: "planning",
      color: "#FF6B35"
    },
    {
      title: t('coordination.mission4.title'),
      description: t('coordination.mission4.description'),
      icon: "tools",
      color: "#9C27B0"
    }
  ];

  return (
    <section className="coordination-chantiers section-animate" id="coordination" ref={sectionRef}>
      <div className="container">
        <div className="section-header">
          <h2 className="section-title title-animate">{t('coordination.title')}</h2>
          <p className="section-subtitle subtitle-animate">
            {t('coordination.subtitle')}
          </p>
        </div>
        
        <div className="missions-chantiers">
          {missions.map((mission, index) => (
            <div key={index} className="mission-chantier stagger-item card-premium focus-premium" style={{'--accent-color': mission.color}} tabIndex="0">
              <div className="mission-icon">
                {renderIcon(mission.icon)}
              </div>
              <div className="mission-content">
                <h3 className="mission-title">{mission.title}</h3>
                <p className="mission-description">{mission.description}</p>
              </div>
            </div>
          ))}
        </div>
        
        <div className="cta-chantier">
          <a href="/contact?type=chantier" className="btn btn-primary btn-large">
            {t('coordination.cta')}
          </a>
        </div>
      </div>
    </section>
  );
};

export default CoordinationChantiers; 